export class OrganizationAppPropertyErrorInfo {
    OrganizationId: string;
    OrganizationName: string;
    Total: number;
    AppPropertyErrorKeys: string[];
}
